export interface MapBlock {
  key: string;
  name: string;
  desc: string;
  entries: number;
  icon: string;
  trend: string;
  tags: string[];
}

export const mapBlocks: MapBlock[] = [
  { key: 'yule', name: '娱乐八卦', desc: '明星动态、影视综综艺与饭圈热议一手掌握', entries: 128, icon: 'ri-star-smile-line', trend: '热', tags: ['明星', '影视', '饭圈'] },
  { key: 'shehui', name: '社会热点', desc: '城市百态与全网热议的民生话题聚集地', entries: 96, icon: 'ri-global-line', trend: '新', tags: ['民生', '城市', '话题'] },
  { key: 'caijing', name: '财经职场', desc: '企业动向、职场话题与消费趋势观察', entries: 74, icon: 'ri-line-chart-line', trend: '升', tags: ['企业', '职场', '消费'] },
  { key: 'keji', name: '科技数码', desc: '新品发布、黑科技与互联网圈大小事', entries: 88, icon: 'ri-rocket-2-line', trend: '热', tags: ['新品', '互联网', 'AI'] },
  { key: 'jingji', name: '电竞体娱', desc: '赛事比分、选手故事与体坛名场面', entries: 63, icon: 'ri-gamepad-line', trend: '新', tags: ['电竞', '体育', '赛事'] },
  { key: 'yingshi', name: '影视综艺', desc: '新片定档、综艺高光与经典老片回忆杀', entries: 102, icon: 'ri-movie-2-line', trend: '升', tags: ['电影', '综艺', '剧集'] },
  { key: 'youxi', name: '游戏圈', desc: '热门新游、版本更新与玩家社区趣闻', entries: 57, icon: 'ri-vip-crown-2-line', trend: '热', tags: ['新游', '版本', '玩家'] },
  { key: 'shenghuo', name: '城市生活', desc: '吃喝玩乐、时尚穿搭与生活灵感分享', entries: 81, icon: 'ri-cup-line', trend: '新', tags: ['生活', '探店', '穿搭'] },
];

export interface HotItem {
  rank: number;
  title: string;
  heat: number;
  tag: string;
  channel: string;
}

export const rankHot: HotItem[] = [
  { rank: 1, title: '年度选秀收官：成团夜霸榜全网热搜', heat: 982, tag: '综艺', channel: '娱乐八卦' },
  { rank: 2, title: '多城音乐节阵容官宣，文旅联动带火周末游', heat: 915, tag: '生活', channel: '城市生活' },
  { rank: 3, title: '暑期档黑马片单陆续定档，影迷开始攒局', heat: 870, tag: '影视', channel: '影视综艺' },
  { rank: 4, title: '新一代影像旗舰发布在即，续航与长焦成焦点', heat: 826, tag: '数码', channel: '科技数码' },
  { rank: 5, title: '职业联赛收官阶段，多队争冠悬念拉满', heat: 790, tag: '体育', channel: '电竞体娱' },
  { rank: 6, title: '国货品牌出海提速，新消费讲出新故事', heat: 743, tag: '财经', channel: '财经职场' },
  { rank: 7, title: '观察类综艺回归，慢生活慢镜头治愈观众', heat: 701, tag: '综艺', channel: '影视综艺' },
  { rank: 8, title: '深夜食堂成年轻人新据点，夜市经济升温', heat: 668, tag: '生活', channel: '城市生活' },
  { rank: 9, title: '季中赛分组出炉，强强对话引爆观赛潮', heat: 612, tag: '电竞', channel: '电竞体娱' },
  { rank: 10, title: 'AI创作工具井喷，内容创作者如何取舍', heat: 588, tag: '互联网', channel: '科技数码' },
];

export const rankWeek: HotItem[] = [
  { rank: 1, title: '新一季歌手竞演开跑，现场翻唱频上热搜', heat: 856, tag: '音乐', channel: '娱乐八卦' },
  { rank: 2, title: '老牌游戏开启怀旧服，玩家集体回忆青春', heat: 802, tag: '游戏', channel: '游戏圈' },
  { rank: 3, title: '县城咖啡店崛起，返乡青年新的生活方式', heat: 755, tag: '生活', channel: '城市生活' },
  { rank: 4, title: '折叠屏价格下探，更多用户开始尝鲜', heat: 709, tag: '数码', channel: '科技数码' },
  { rank: 5, title: '一部高分冷门剧逆袭，口碑发酵成黑马', heat: 680, tag: '影视', channel: '影视综艺' },
  { rank: 6, title: '打工人工作群聊引热议：高效沟通成刚需', heat: 645, tag: '职场', channel: '财经职场' },
  { rank: 7, title: '本土户外品牌走红，山系穿搭风格出圈', heat: 601, tag: '时尚', channel: '城市生活' },
  { rank: 8, title: '电竞战队更替引关注，青训体系成讨论热点', heat: 572, tag: '电竞', channel: '电竞体娱' },
  { rank: 9, title: '即时零售竞争白热化，半小时达成新常态', heat: 540, tag: '消费', channel: '财经职场' },
  { rank: 10, title: '二次元漫展人气爆棚，跨界联名层出不穷', heat: 516, tag: '兴趣', channel: '游戏圈' },
];

export const rankRising: HotItem[] = [
  { rank: 1, title: '一部争议剧大结局，观众为角色命运吵翻', heat: 934, tag: '影视', channel: '影视综艺' },
  { rank: 2, title: '城市骑行风潮兴起，骑行路线笔记刷屏', heat: 812, tag: '生活', channel: '城市生活' },
  { rank: 3, title: '新款轻薄本卷续航，办公党直呼心动', heat: 766, tag: '数码', channel: '科技数码' },
  { rank: 4, title: '综艺导师阵容曝光，老带新模式引期待', heat: 728, tag: '综艺', channel: '娱乐八卦' },
  { rank: 5, title: '公募明星经理调仓，基民关注长期布局', heat: 694, tag: '财经', channel: '财经职场' },
  { rank: 6, title: '世界赛预选阶段开战，老将新星同台竞技', heat: 651, tag: '电竞', channel: '电竞体娱' },
  { rank: 7, title: '线下剧本杀回归潮，社交新玩法重新走热', heat: 609, tag: '兴趣', channel: '城市生活' },
  { rank: 8, title: '手机影像大赛获奖作品出圈，随手拍成艺术', heat: 563, tag: '数码', channel: '科技数码' },
  { rank: 9, title: '演唱会一票难求，演出经济持续火爆', heat: 521, tag: '音乐', channel: '娱乐八卦' },
  { rank: 10, title: '独立游戏工作室获关注，小而美作品受宠', heat: 487, tag: '游戏', channel: '游戏圈' },
];

export interface PlatformEntry {
  name: string;
  desc: string;
  icon: string;
  theme: string;
  url: string;
}

export const platforms: PlatformEntry[] = [
  { name: '微博热榜', desc: '实时热搜与话题广场', icon: 'ri-fire-line', theme: 'text-primary-600 bg-primary-50', url: 'https://s.weibo.com/top/summary' },
  { name: '知乎热榜', desc: '问答与事件深度讨论', icon: 'ri-question-line', theme: 'text-secondary-700 bg-secondary-100', url: 'https://www.zhihu.com/hot' },
  { name: '抖音热点', desc: '短视频热点与挑战话题', icon: 'ri-vidicon-line', theme: 'text-foreground-700 bg-foreground-100', url: 'https://www.douyin.com/hot' },
  { name: 'B站热门', desc: '鬼畜、生活与知识区热榜', icon: 'ri-play-circle-line', theme: 'text-accent-700 bg-accent-100', url: 'https://www.bilibili.com/v/popular/rank/all' },
  { name: '百度热点', desc: '全网搜索聚合的即时热点', icon: 'ri-search-eye-line', theme: 'text-primary-700 bg-primary-100', url: 'https://top.baidu.com/board?tab=realtime' },
  { name: '头条热榜', desc: '资讯与资讯号热门内容', icon: 'ri-news-line', theme: 'text-secondary-800 bg-secondary-100', url: 'https://www.toutiao.com/hot' },
];

export interface EventItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  channel: string;
  tag: string;
  image: string;
  hot: number;
  time: string;
}

export const eventList: EventItem[] = [
  {
    id: 'ev-01',
    title: '选秀成团夜话题量破亿，舞台名场面刷屏',
    summary: '一年一度的成团夜落下帷幕，数个舞台高光片段在社交平台迅速传播，粉丝应援与导师点评共同推高讨论热度。',
    category: '综艺',
    channel: '娱乐八卦',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=stage%20spotlight%20with%20colorful%20confetti%20and%20silhouette%20dancers%20performing%20under%20warm%20neon%20lights%2C%20vibrant%20entertainment%20show%20concert%20atmosphere%2C%20cinematic%20media%20photo%20style&width=800&height=560&seq=chigua-event-01&orientation=landscape',
    hot: 982,
    time: '12分钟前',
  },
  {
    id: 'ev-02',
    title: '音乐节联名文旅路线，周末出游迎小高峰',
    summary: '多个城市音乐节陆续官宣，主办方与文旅部门联动推出观演+旅游线路，带动周边酒店与餐饮消费同步升温。',
    category: '生活',
    channel: '城市生活',
    tag: '生活',
    image: 'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20with%20warm%20golden%20hour%20stage%20lights%2C%20hand%20up%20silhouettes%2C%20festive%20summer%20vibe%2C%20vibrant%20editorial%20photography&width=800&height=560&seq=chigua-event-02&orientation=landscape',
    hot: 915,
    time: '26分钟前',
  },
  {
    id: 'ev-03',
    title: '暑期档黑马片单定档，影迷自发组团观影',
    summary: '多部口碑佳作接连定档暑期，题材覆盖剧情、科幻与动画，影迷社群围绕排片与预售展开热烈讨论。',
    category: '影视',
    channel: '影视综艺',
    tag: '影视',
    image: 'https://readdy.ai/api/search-image?query=cinema%20poster%20wall%20with%20warm%20marquee%20lights%20and%20popcorn%2C%20movie%20theater%20entrance%20at%20night%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=chigua-event-03&orientation=landscape',
    hot: 870,
    time: '40分钟前',
  },
  {
    id: 'ev-04',
    title: '新一代影像旗舰定档，长焦夜景成最大悬念',
    summary: '新一代影像旗舰官宣发布时间，爆料聚焦潜望长焦与夜景算法升级，数码爱好者已开始整理对比预测。',
    category: '数码',
    channel: '科技数码',
    tag: '数码',
    image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20on%20minimal%20studio%20desk%20with%20soft%20abstract%20orange%20and%20cream%20background%2C%20clean%20product%20photography%2C%20tech%20editorial%20style&width=800&height=560&seq=chigua-event-04&orientation=landscape',
    hot: 826,
    time: '1小时前',
  },
  {
    id: 'ev-05',
    title: '职业联赛收官阶段，多队争冠悬念拉满',
    summary: '常规赛临近尾声，积分榜咬得很紧，多支球队保留争冠与出线希望，球迷围绕赛程与战术展开讨论。',
    category: '体育',
    channel: '电竞体娱',
    tag: '体育',
    image: 'https://readdy.ai/api/search-image?query=stadium%20night%20match%20with%20bright%20floodlights%20and%20green%20pitch%2C%20dynamic%20sports%20arena%20crowd%2C%20energetic%20atmosphere%2C%20editorial%20sports%20photography&width=800&height=560&seq=chigua-event-05&orientation=landscape',
    hot: 790,
    time: '1小时前',
  },
  {
    id: 'ev-06',
    title: '国货品牌出海提速，新消费讲出新故事',
    summary: '一批国货品牌加速布局海外市场，凭借供应链与本土化运营打开销路，也引发关于品牌长期主义的讨论。',
    category: '财经',
    channel: '财经职场',
    tag: '财经',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimal%20city%20skyline%20skyline%20with%20warm%20dawn%20light%20and%20abstract%20growth%20chart%20elements%2C%20business%20finance%20concept%2C%20clean%20editorial%20illustration&width=800&height=560&seq=chigua-event-06&orientation=landscape',
    hot: 743,
    time: '2小时前',
  },
  {
    id: 'ev-07',
    title: '深夜食堂成年轻人新据点，夜市经济升温',
    summary: '多个城市夜市焕新回归，特色小摊与氛围感街区吸引年轻消费者，深夜消费正成为新的生活潮流。',
    category: '生活',
    channel: '城市生活',
    tag: '生活',
    image: 'https://readdy.ai/api/search-image?query=cozy%20night%20street%20food%20stall%20with%20warm%20hanging%20lights%20and%20steam%20rising%2C%20vibrant%20urban%20night%20market%20atmosphere%2C%20editorial%20food%20photography&width=800&height=560&seq=chigua-event-07&orientation=landscape',
    hot: 668,
    time: '2小时前',
  },
  {
    id: 'ev-08',
    title: '季中赛分组出炉，强强对话引爆观赛潮',
    summary: '季中赛分组名单公布，多个小组出现强强对决，赛程安排与观赛福利成为电竞社区热议焦点。',
    category: '电竞',
    channel: '电竞体娱',
    tag: '电竞',
    image: 'https://readdy.ai/api/search-image?query=esports%20arena%20with%20large%20screens%20showing%20gameplay%20and%20colorful%20stage%20lights%2C%20professional%20gaming%20competition%20atmosphere%2C%20editorial%20photography&width=800&height=560&seq=chigua-event-08&orientation=landscape',
    hot: 612,
    time: '3小时前',
  },
];

export const eventCategories: string[] = ['全部', '综艺', '影视', '数码', '体育', '电竞', '财经', '生活'];

export const faqList = [
  {
    q: '吃瓜入口网到底是什么网站？',
    a: '吃瓜入口网是一个全网瓜田导航首页，不生产内容，而是像一张"瓜田地图"一样，把各平台活跃板块与热门事件按图索骥地整理好，方便你快速找到自己感兴趣的瓜，再跳转围观。',
  },
  {
    q: '这里的资讯内容从哪来？',
    a: '吃瓜入口地图收录的板块入口均指向各平台的公开内容与话题，吃瓜入口索引则聚合近期被广泛讨论的热点事件线索，帮助你在最短时间内掌握讨论脉络。',
  },
  {
    q: '内容多久更新一次？',
    a: '热门板块与热搜总榜会持续跟踪并频繁更新，最新事件板块按热度与时效滚动刷新，力争让吃瓜入口大全里始终是当下最有讨论度的话题。',
  },
  {
    q: '吃瓜入口网收费吗？',
    a: '完全免费。我们把吃瓜入口首页定位成公开的导航工具，用户无需注册即可使用索引与地图功能，未来若新增高级功能也会提前透明说明。',
  },
  {
    q: '转载与版权问题如何处理？',
    a: '吃瓜入口网尊重各方版权，仅提供指向公开内容与讨论页面的导航与索引，不复制原文。我们鼓励大家前往原平台了解完整信息与最新进展。',
  },
  {
    q: '如何反馈问题或提供新鲜瓜线索？',
    a: '你可以通过页脚的反馈入口或示例邮箱与我们联系，无论是导航失效、分类建议，还是想要推荐新的活跃板块，我们都欢迎随时告诉我们。',
  },
];

export const reputation = [
  { icon: 'ri-focus-3-line', stat: '收录板块', value: '1200+' },
  { icon: 'ri-time-line', stat: '高频更新', value: '实时' },
  { icon: 'ri-road-map-line', stat: '分类地图', value: '八大类' },
  { icon: 'ri-shield-check-line', stat: '来源透明', value: '可追溯' },
];